import React from "react";
import Dashboard from "../layouts/Dashboard/Dashboard.jsx";
import LoginView from "../views/Login/LoginForm/Login.view.js";
import { Route, Switch } from "react-router-dom";
import LoginDietitian from "../views/LoginDietitian/LoginDietitian.view.js";
import Otp from "../views/OtpVerify/OtpVerify.view.js";

const App = () => {
  return <div> hi</div>;
};
const RouteComponent = () => (
  <Switch>
    {/* <Route path={"/login"} component={LoginView} /> */}
    <Route path={"/login"} component={LoginDietitian}/>
    <Route path={"/otp"} component={Otp}/>
    <Route path={"/"} component={Dashboard} />
  </Switch>
);
export default RouteComponent;
